export const LOCALES = [
  { id: 1, name: 'English', slug: 'en' },
  { id: 2, name: 'Polski', slug: 'pl' },
] as const
